// V1.0 — Dashboard / Search / Settings / Reports data-testid registry.
export const V1 = {
  // Dashboard
  dashPage: "dashboard-page",
  dashRefresh: "dashboard-refresh",
  cardTodaySales: "dash-today-sales",
  cardMTDSales: "dash-mtd-sales",
  cardPendingProcure: "dash-pending-procure",
  cardPendingQC: "dash-pending-qc",
  cardPendingDispatch: "dash-pending-dispatch",
  cardOpenCases: "dash-open-cases",
  cardWarrantyDue: "dash-warranty-due",
  cardCampaignRunning: "dash-campaign-running",
  cardInventoryValue: "dash-inventory-value",
  cardDeadStock: "dash-dead-stock",
  topCustomers: "dash-top-customers",
  topVendors: "dash-top-vendors",
  fastMoving: "dash-fast-moving",
  recentActivity: "dash-recent-activity",

  // Search
  searchOpenBtn: "global-search-open",
  searchInput: "global-search-input",
  searchResult: (idx) => `global-search-result-${idx}`,
  searchRecent: (idx) => `global-search-recent-${idx}`,
  searchClose: "global-search-close",

  // Settings
  settingsPage: "settings-page",
  settingsSection: (key) => `settings-section-${key}`,
  settingsSaveBtn: (key) => `settings-save-${key}`,

  // Reports
  reportsPage: "reports-page",
  reportsType: "reports-type-select",
  reportsFormat: "reports-format-select",
  reportsStart: "reports-start-date",
  reportsEnd: "reports-end-date",
  reportsDownload: "reports-download-btn",

  // Nav
  navDashboard: "nav-dashboard",
  navSettings: "nav-settings",
  navReports: "nav-reports",
};
